import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { SelectableOption } from '@models/selectable-option';

@Component({
  selector: 'app-hair-loss-treatment',
  templateUrl: './hair-loss-treatment.component.html',
  styleUrls: ['./hair-loss-treatment.component.scss'],
  imports: [UpsellCardComponent],
})
export class HairLossTreatmentComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.OralMinoxidil;
  public readonly options: SelectableOption[] = [
    new SelectableOption('Yes, add Minoxidil', UpsellSlugs.OralMinoxidil),
    new SelectableOption('Yes, add Finasteride', UpsellSlugs.OralFinasteride),
    new SelectableOption("No, I don't want to try hair loss treatment at this time", QuestionnaireAnswers.No),
  ];
}
